module.exports = __webpack_public_path__ + "4ecab2926391180624b0236fceea7d6c.png";